<template>
  <div class="content-single-8">
    <m-single-content-wrapper :contentLink="contentLink"
                              @content="init"
                              content-type="page">
      <template v-slot="{content}">
        <div class="row justify-content-center align-items-center p-2">
          <div class="col-lg-6 text-center mx-auto">
            <video v-if="content.keywords" :id="`video-${content.id}`" :muted="muted" :autoplay="autoplay"
                   :controls="controls"
                   :poster="content.thumbnail"
                   class="mx-auto content-single-8-video text-center">
              <source :src="content.keywords[0].keyword" type="video/mp4">
              <source :src="content.keywords[0].keyword" type="video/ogg">
              Your browser does not support the video tag.
            </video>

          </div>
          <div class="col-lg-6 content-single-8-content-wrapper">
            <h3>{{ content.title }}</h3>
            <div class="content-single-8-content-description" v-html="content.body"></div>
            <div class="container content-single-8-content-button">
              <m-a :href="findLinkOnContent(content.abstraction)">
                <m-button301 class="bg-primary" v-t="`content.single.more`"></m-button301>
              </m-a>
            </div>
          </div>
        </div>
      </template>
    </m-single-content-wrapper>
  </div>
</template>

<script>
import {ContentSingleProps} from "./ContentSingleProps";
import mSingleContentWrapper from "../../Wrappers/SingleContentWrapper";
import mA from "../../Tags/A";
import mButton2 from "../../Buttons/Button2";
import mCard906 from "../../Cards/Card906";
import mButton301 from "../../Buttons/Button301";
import Heading2 from "../../Heading/Heading2";

export default {
  name: "ContentSingle8",
  components: {Heading2, mA, mSingleContentWrapper, mButton2, mCard906, mButton301},
  props: {
    ...ContentSingleProps,
    // todo read video props from file, issue: video prop not merge with other props
    controls: {
      type: Boolean,
      default: true
    },
    videoSrc: {
      default: ''
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    muted: {
      type: Boolean,
      default: false
    },
    playWhenVisible: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    playWhenVisibleFunction(content) {
      // add setTimeout to make sure items inside wrapper generate, and it is inside the page.
      setTimeout(() => {
        let contentData = content.data.data

        const video = document.getElementById(`video-${contentData.id}`);

        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              console.log('play')
              entry.target.play();
            } else {
              console.log('pause')
              entry.target.pause();
            }
          });
        });

        observer.observe(video);
      }, 100)
    },
    init(content) {
      if (this.playWhenVisible) {
        this.playWhenVisibleFunction(content)
      }
    }
  }

}
</script>

<style scoped>
.content-single-8-video {
  width: 100%;
}

.card906 >>> .card906-content .row {
  height: 100%;
  margin: auto;
}
</style>